import { useState } from 'react';
import { Link } from 'react-router-dom';
import { TextField, Button, Typography, CircularProgress, Alert } from '@mui/material';
import AuthAlert from '../components/AuthAlert';
import AuthCard from '../components/AuthCard';
import api from '../api/client';
import { apiError } from '../i18n/errors';
import { colors } from '../colors';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.post('/auth/forgot-password/', { email });
      setSent(true);
    } catch (err) {
      setError(apiError(err, 'Une erreur est survenue. Réessayez.'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthCard title="Réinitialisation du mot de passe">
      <Typography variant="h6" sx={{ color: colors.textPrimary, textAlign: 'center' }}>
        Mot de passe oublié
      </Typography>

      {sent ? (
        <>
          <Alert severity="success" sx={{ bgcolor: 'rgba(34,197,94,0.15)', color: colors.success, border: '1px solid rgba(34,197,94,0.3)' }}>
            Si un compte existe avec cette adresse, un email de réinitialisation a été envoyé.
          </Alert>
          <Typography variant="body2" color="text.secondary" textAlign="center">
            Vérifiez votre boîte de réception et vos spams.
          </Typography>
        </>
      ) : (
        <>
          <Typography variant="body2" sx={{ color: colors.textSecondary, textAlign: 'center' }}>
            Entrez votre adresse email et nous vous enverrons un lien pour réinitialiser votre mot de passe.
          </Typography>

          {error && <AuthAlert>{error}</AuthAlert>}

          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <TextField label="Email" type="email" required fullWidth autoFocus
              disabled={loading}
              value={email} onChange={(e) => setEmail(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter') handleSubmit(e); }} />
            <Button type="submit" variant="contained" color="primary" fullWidth size="large"
              disabled={loading}
              sx={{ py: 1.5, fontSize: '1rem', fontWeight: 700 }}>
              {loading ? <CircularProgress size={24} sx={{ color: 'white' }} /> : 'Envoyer le lien'}
            </Button>
          </form>
        </>
      )}

      <Typography textAlign="center" variant="body2" sx={{ color: colors.textSecondary }}>
        <Link to="/login" style={{ color: colors.primaryLight, fontWeight: 600, textDecoration: 'none' }}>
          ← Retour à la connexion
        </Link>
      </Typography>
    </AuthCard>
  );
}
